import {
  GET_HOUSEHOLDS_SUCCESS,
  GET_HOUSEHOLDS_FAIL,
  ADD_HOUSEHOLD_SUCCESS,
  ADD_HOUSEHOLD_FAIL,
  UPDATE_HOUSEHOLD_SUCCESS,
  UPDATE_HOUSEHOLD_FAIL,
  GET_HOUSEHOLD_DETAIL_SUCCESS,
  GET_HOUSEHOLD_DETAIL_FAIL,
  GET_TRAININGMONTHS_SUCCESS,
  GET_TRAININGMONTHS_FAIL,
  GET_TRAININGTYPES_SUCCESS,
  GET_TRAININGTYPES_FAIL,
  GET_TRAININGSUBJECTS_SUCCESS,
  GET_TRAININGSUBJECTS_FAIL,
  CLEAR_HOUSEHOLD_STATE,
  ADD_HOUSEHOLD_FILEUPLOAD_SUCCESS,
  ADD_HOUSEHOLD_FILEUPLOAD_FAIL,
  ADD_HOUSEHOLD_DATAUPLOAD,
  ADD_HOUSEHOLD_DATAUPLOAD_SUCCESS,
  ADD_HOUSEHOLD_DATAUPLOAD_FAIL,
  ADD_SUBJECT_SUCCESS,
  ADD_SUBJECT_FAIL,
  UPDATE_SUBJECT_SUCCESS,
  UPDATE_SUBJECT_FAIL,
  GET_SUBJECT_DETAIL_SUCCESS,
  GET_SUBJECT_DETAIL_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  households: [],
  household: {},
  trainingsubjects: [],
  trainingtypes: [],
  trainingmonths: [],
  trainingsubject: {},
  result: {},
  error: {},
  loading: true,
}

const Household = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_HOUSEHOLDS_SUCCESS:
      return {
        ...state,
        households: action.payload,
        loading: true,
      }
    case GET_HOUSEHOLDS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_HOUSEHOLD_DETAIL_SUCCESS:
      return {
        ...state,
        household: action.payload,
        loading: true,
      }
    case GET_HOUSEHOLD_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_HOUSEHOLD_SUCCESS:
      return {
        ...state,
        households: action.payload,
      }
    case ADD_HOUSEHOLD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_HOUSEHOLD_SUCCESS:
      return {
        ...state,
        households: state.households.map(p =>
          p.HouseholdID.toString() === action.payload.HouseholdID.toString()
            ? { p, ...action.payload }
            : p
        ),
      }
    case UPDATE_HOUSEHOLD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_TRAININGMONTHS_SUCCESS:
      return {
        ...state,
        trainingmonths: action.payload,
        loading: true,
      }
    case GET_TRAININGMONTHS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_TRAININGTYPES_SUCCESS:
      return {
        ...state,
        trainingtypes: action.payload,
        loading: true,
      }
    case GET_TRAININGTYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_TRAININGSUBJECTS_SUCCESS:
      return {
        ...state,
        trainingsubjects: action.payload,
        loading: true,
      }
    case GET_TRAININGSUBJECTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_HOUSEHOLD_FILEUPLOAD_SUCCESS:
      return {
        ...state,
        result: action.payload,
        loading: true,
      }
    case ADD_HOUSEHOLD_FILEUPLOAD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_HOUSEHOLD_DATAUPLOAD:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case ADD_HOUSEHOLD_DATAUPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      }
    case ADD_HOUSEHOLD_DATAUPLOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case GET_SUBJECT_DETAIL_SUCCESS:
      return {
        ...state,
        trainingsubject: action.payload,
        loading: true,
      }
    case GET_SUBJECT_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_SUBJECT_SUCCESS:
      return {
        ...state,
        trainingsubjects: action.payload,
      }
    case ADD_SUBJECT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_SUBJECT_SUCCESS:
      return {
        ...state,
        trainingsubjects: state.trainingsubjects.map(p =>
          p.TrainingSubjectID.toString() ===
          action.payload.TrainingSubjectID.toString()
            ? { p, ...action.payload }
            : p
        ),
      }
    case UPDATE_SUBJECT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_HOUSEHOLD_STATE:
      return {
        households: [],
        household: {},
        trainingsubjects: [],
        trainingtypes: [],
        trainingmonths: [],
        trainingsubject: {},
        result: {},
      }
    default:
      return state
  }
}

export default Household
